import React from "react";

function CCTVIntro() {
    return (
        <div>
            <h2>Introduction to CCTV Operations</h2>
            <p>
                Closed Circuit Television (CCTV) systems are a vital part of modern security infrastructure. This module introduces the purpose, scope, and responsibilities of CCTV operators in protecting people, property, and public spaces.
            </p>

            <h3>Purpose of CCTV Surveillance</h3>
            <ul>
                <li>Monitor public and private spaces for safety and security</li>
                <li>Prevent and detect crime and anti-social behavior</li>
                <li>Assist emergency services and law enforcement</li>
                <li>Provide evidence for investigations and prosecutions</li>
                <li>Support crowd control and incident management</li>
            </ul>

            <h3>Typical CCTV Environments</h3>
            <ul>
                <li>Shopping centres and retail stores</li>
                <li>Transport hubs (airports, train stations)</li>
                <li>Hospitals and schools</li>
                <li>Public streets and town centres</li>
                <li>Industrial sites and office buildings</li>
            </ul>

            <h3>Key Responsibilities of a CCTV Operator</h3>
            <ul>
                <li>Monitor live feeds and recorded footage</li>
                <li>Identify and report suspicious activity</li>
                <li>Operate equipment and maintain system integrity</li>
                <li>Follow legal and ethical guidelines</li>
                <li>Liaise with emergency services when necessary</li>
            </ul>

            <h3>Legal Considerations</h3>
            <ul>
                <li>Operate within the <strong>Data Protection Act 2018</strong></li>
                <li>Respect privacy and human rights</li>
                <li>Only use footage for legitimate security purposes</li>
                <li>Understand the <strong>Surveillance Camera Code of Practice</strong></li>
            </ul>

            <h3>Licensing Requirements</h3>
            <ul>
                <li>Must be 18 years or older</li>
                <li>Complete an approved SIA CCTV Operator training course</li>
                <li>Hold a valid Emergency First Aid at Work certificate</li>
                <li>Pass identity and criminal background checks</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/cctv" target="_blank" rel="noreferrer">UK Gov – CCTV Overview</a></li>
                <li><a href="https://www.gov.uk/government/publications/surveillance-camera-code-of-practice" target="_blank" rel="noreferrer">Surveillance Camera Code of Practice</a></li>
                <li><a href="https://www.sia.homeoffice.gov.uk/" target="_blank" rel="noreferrer">SIA – CCTV Licensing</a></li>
            </ul>
        </div>
    );
}

export default CCTVIntro;
